import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'

export const TeamMemberMain = styled.div`
  & + & {
    ${clamp('margin-top', 25, 50)}
  }
`
